module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }